import { useEffect, useState } from 'react'

interface Props {
  workDuration: number
  travelDuration: number
  departureDuration: number
  onWorkChange: (v: number) => void
  onTravelChange: (v: number) => void
  onDepartureChange: (v: number) => void
}

function DurationField({
  label,
  value,
  onChange,
}: {
  label: string
  value: number
  onChange: (v: number) => void
}) {
  const [draft, setDraft] = useState(String(value))

  useEffect(() => {
    setDraft(String(value))
  }, [value])

  function commit(n: number) {
    setDraft(String(n))
    onChange(n)
  }

  return (
    <div className="flex flex-col gap-1 flex-1">
      <span className="text-xs text-gray-500 font-medium">{label}</span>
      <div className="flex items-stretch">
        <button
          type="button"
          onClick={() => commit(Math.max(0, value - 15))}
          disabled={value <= 0}
          aria-label={`${label} verringern`}
          className="h-9 w-9 shrink-0 border border-gray-300 rounded-l-lg text-gray-700 text-base font-medium active:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          −
        </button>
        <input
          type="number"
          min={0}
          inputMode="numeric"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={() => {
            const num = Math.max(0, Number(draft) || 0)
            setDraft(String(num))
            onChange(num)
          }}
          className="flex-1 min-w-0 border-y border-gray-300 rounded-none px-1 text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:z-10"
        />
        <button
          type="button"
          onClick={() => commit(value + 15)}
          aria-label={`${label} erhöhen`}
          className="h-9 w-9 shrink-0 border border-gray-300 rounded-r-lg text-gray-700 text-base font-medium active:bg-gray-100"
        >
          +
        </button>
      </div>
    </div>
  )
}

export function DurationInputs({
  workDuration,
  travelDuration,
  departureDuration,
  onWorkChange,
  onTravelChange,
  onDepartureChange,
}: Props) {
  return (
    <div className="flex flex-col gap-3 px-4 py-3 border-t border-gray-100">
      <DurationField label="Nettoarbeitszeit" value={workDuration} onChange={onWorkChange} />
      <div className="grid grid-cols-2 gap-3 ">
      <DurationField label="Anfahrt" value={travelDuration} onChange={onTravelChange} />
      <DurationField label="Abfahrt" value={departureDuration} onChange={onDepartureChange} />
      </div>
    </div>
  )
}
